import axios from "axios";

import { API_BASE_URL } from '../config';


// Get landing page by key
export const getLandingPageByKey = async (key, lang = "fr") => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}landing_page/${key}?lang=${
        lang === "uk" ? "en" : lang
      }`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error fetching landing page:", error);
    throw error;
  }
};

// // Save config to localStorage
// export const saveConfig = (hideHeader, hideFooter, color) => {
//   localStorage.setItem("hideHeader", hideHeader);
//   localStorage.setItem("hideFooter", hideFooter);
//   localStorage.setItem("color", color);

//   console.log("Config saved:", { hideHeader, hideFooter, color });
// };

// // Clear config from localStorage
// export const clearConfig = () => {
//   localStorage.removeItem("hideHeader");
//   localStorage.removeItem("hideFooter");
//   localStorage.removeItem("color");

//   console.log("Config cleared");
// };

// // Get the hideHeader config from localStorage
// export const getHideHeader = () => {
//   return localStorage.getItem("hideHeader") === "1";
// };

// // Get the hideFooter config from localStorage
// export const getHideFooter = () => {
//   return localStorage.getItem("hideFooter") === "1";
// };

// // Get the color config from localStorage
// export const getColor = () => {
//   return localStorage.getItem("color");
// };
